import React from 'react';

/* Retorna un componente que truncará el texto y mostrará el contenido completo en un tooltip si tiene más de 50 caracteres */
const TrimmedText = ({ text, size }) => {
    // Ref para el elemento que contendrá el texto truncado
    const spanRef = React.useRef(null);
    // Estado para controlar la posición del tooltip
    const [tooltipPosition, setTooltipPosition] = React.useState({ x: 0, y: 0 });

    // Función para mostrar el tooltip y establecer su posición al lado del mouse
    const handleMouseOver = (event) => {
        const { clientX, clientY } = event;
        setTooltipPosition({ x: clientX, y: clientY });
    };

    // Función para ocultar el tooltip cuando el mouse sale del elemento
    const handleMouseOut = () => {
        setTooltipPosition({ x: 0, y: 0 });
    };

    return (
        <span
            ref={spanRef}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            style={{ cursor: 'auto', position: 'relative' }}
        >
            {/* Muestra el texto truncado */}
            {text.length > size ? text.substring(0, size) + '...' : text}

            {/* Muestra el tooltip si el texto tiene más de 50 caracteres */}
            {text.length > size && tooltipPosition.x !== 0 && (
                <div
                    style={{
                        position: 'fixed',
                        backgroundColor: '#f0f0f0',
                        padding: '5px',
                        border: '1px solid #ccc',
                        borderRadius: '5px',
                        zIndex: '1000',
                        left: `${tooltipPosition.x + 10}px`,
                        top: `${tooltipPosition.y}px`,
                    }}
                >
                    {/* Muestra el contenido completo */}
                    {text}
                </div>
            )}
        </span>
    );
};

export default TrimmedText;
